import React from 'react';
import { AlertCircle } from 'lucide-react';
import type { SolutionHeroWidget } from './solutionHeroWidgets';

const MiniChart: React.FC<{ tone: SolutionHeroWidget['tone'] }> = ({ tone }) => (
  <div className={`solution-hero__widget-chart solution-hero__widget-chart--${tone}`} aria-hidden>
    <svg viewBox="0 0 80 28" preserveAspectRatio="none">
      <polyline
        points="0,22 12,18 24,20 36,10 48,14 60,6 72,12 80,4"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </div>
);

const MiniGauge: React.FC<{ value: string }> = ({ value }) => (
  <div className="solution-hero__widget-gauge" aria-hidden>
    <svg viewBox="0 0 64 36">
      <path d="M8 32 A24 24 0 0 1 56 32" fill="none" stroke="#e2e8f0" strokeWidth="5" />
      <path d="M8 32 A24 24 0 0 1 44 14" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
    </svg>
    <span>{value}%</span>
  </div>
);

export const SolutionHeroWidgetCard: React.FC<{ widget: SolutionHeroWidget }> = ({ widget }) => (
  <div
    className={`solution-hero__widget solution-hero__widget--${widget.position} solution-hero__widget--${widget.tone}`}
    aria-hidden
  >
    <div className="solution-hero__widget-head">
      {widget.kind === 'alert' ? (
        <AlertCircle size={14} strokeWidth={2.25} />
      ) : (
        <span className={`solution-hero__widget-dot solution-hero__widget-dot--${widget.tone}`} />
      )}
      <span>{widget.badge}</span>
    </div>
    <p className="solution-hero__widget-label">{widget.label}</p>
    <p className="solution-hero__widget-value">
      {widget.value}
      {widget.unit ? <span>{widget.unit}</span> : null}
    </p>
    {widget.kind === 'alert' || widget.kind === 'status' ? (
      <MiniChart tone={widget.tone} />
    ) : (
      <MiniGauge value={widget.value} />
    )}
  </div>
);
